import type { PaymentMethod } from "../types";

export { generateCheckoutRequestId, getOrCreateCheckoutRequestId, withRequestId } from "./checkout-request-id";
export { validateFormFields } from "./validate-form-fields";

export const $ = (selector: string) => {
  const ele = document.querySelector(selector);
  if (!ele) {
    throw new Error(`Cannot find element with selector: ${selector}`);
  }
  return ele;
};

export const definePaymentMethod = <TExternalFuncs, TName extends string>(
  paymentMethod: PaymentMethod<TExternalFuncs, TName>,
) => paymentMethod;

export const createCheckoutIFrame = (type: string, baseUrl: string, params?: Record<string, string>) => {
  const iframe = document.createElement("iframe");

  const searchParams = new URLSearchParams(params);
  const searchParamsStr = searchParams.toString();

  iframe.src = `${baseUrl}/embeds/v1/${type}${searchParamsStr ? `?${searchParamsStr}` : ""}`;

  Object.assign(iframe.style, { width: "100%", height: "100%", border: "none" });

  return iframe;
};

/**
 * Collects browser and client information for fraud detection.
 */
export function collectFraudMetadata() {
  return {
    ipAddress: undefined, // IP address should be collected server-side
    browserInfo: {
      userAgent: navigator.userAgent,
      language: navigator.language,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      colorDepth: window.screen.colorDepth,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    processorFraudInfo: undefined,
  };
}

type AddressInput = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  country?: string;
};

type AddressOutput = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
};

/**
 * Maps address fields from snake_case to camelCase format.
 */
export function mapAddress(address?: AddressInput): AddressOutput | undefined {
  if (!address) return undefined;

  return {
    line1: address.line1,
    line2: address.line2,
    city: address.city,
    state: address.state,
    zipCode: address.zip_code,
    country: address.country,
  };
}
